var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M23 57h18v6H23zM19 47h26v10H19zM41 47v-4l7-13L32 1 16 30l7 13v4","key":0}),React.createElement("circle",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","cx":"32","cy":"28.875","r":"4","key":1}),React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M32 1v24","key":2})]);
}

Pen.defaultProps = {"version":"1.0","width":"64","height":"64"};

module.exports = Pen;

Pen.default = Pen;
